<script>
import {
} from 'vue-feather-icons';

import Navbar from "@/view/front/components/navbar";
import IndexService from "@/MainServices/IndexService.js";
import Footer from "@/view/front/components/footer";
import Swal from "sweetalert2";

/**
 * Page-contact-detail component
 */
export default {
    data() {
        return {
        }
    },
    components: {
        Navbar,
        Footer,
    },
    methods: {
    }
}
</script>

<template>
<div>
    <Navbar />
    <section class="_404 mt-25">
      <div class="container">
      <div class="row m-0 p-0">
        <div class="col-md-6 col-sm-12 align-middle">
          <img src="images/404.svg" alt="404">
        </div>
        <div class="col-md-6 col-sm-12 pt-30 pl-20">
          <h1 class="heading mb-10">OOPS !</h1>
          <p class="pb-5">Looks like you’re on wrong page or We’re working on it.</p>
          <a href="/">Back to Homepage</a>
        </div>
      </div>
    </div>
    </section>
    <Footer />
    <a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
</div>
</template>

<style>
.modal-content {
    background-color: transparent;
}
</style>
